import { createContext } from "react";
import { graphql } from "relay-runtime";

import type { VehicleTypeCategoriesQuery$data } from "__generated__/VehicleTypeCategoriesQuery.graphql";

export const vehicleTypeCategoriesQuery = graphql`
  query VehicleTypeCategoriesQuery {
    vehicleTypeCategories {
      vehicleTypes
      dockTypes
      controllerTypes
      accessPointTypes
      otherTypes
    }
  }
`;

export interface VehicleTypeCategoriesContextType {
  categories: VehicleTypeCategoriesQuery$data;
}
export const VehicleTypeCategoriesContext = createContext<VehicleTypeCategoriesContextType | null>(
  null
);
